// Views
import HrTeamsIndex from "../../Views/Hr/Teams/Index";
import HrTeamsForm from "../../Views/Hr/Teams/Form";
import HrTeamsLayout from "../../Views/Hr/Teams/Layout";

export default [
    {
        path:'/hr/teams',
        component:HrTeamsIndex,
        name:'hr.teams.index',
    },
    {
        path:'/hr/teams/add',
        component:HrTeamsForm,
        name:'hr.teams.add',
    },
    {
        path:'/hr/teams/:id',
        component:HrTeamsLayout,
        children:[
            {
                path:'edit',
                component:HrTeamsForm,
                name:'hr.teams.edit',
            },
        ]
    },
];
